import { suggest, geocode } from "@esri/arcgis-rest-geocoding";
import { ESRI_API_KEY } from "../../../config/_entrypoint";

const getInitialState = () => ({
  GEOCODE_QUERY: "",
  GEOCODE_SUGGESTIONS: [],
  GEOCODE_SELECTED: null,
  GEOCODE_CANDIDATES: [],
  GEOCODE_IS_LOADING: false,
  GEOCODE_DEBOUNCE_TIMEOUT: null,
});

const state = getInitialState();

const getters = {
  GEOCODE_PRIMARY_CANDIDATE: (state) => {
    return state.GEOCODE_CANDIDATES[0] || null;
  },
};

const mutations = {
  GEOCODE_SET_LOADING(state) {
    state.GEOCODE_IS_LOADING = true;
  },

  GEOCODE_SET_QUERY(state, query) {
    state.GEOCODE_QUERY = query;
    state.message = null;
    state.messageType = null;
  },
  GEOCODE_SET_SUGGESTIONS(state, suggestions) {
    state.GEOCODE_SUGGESTIONS = suggestions;
    state.GEOCODE_IS_LOADING = false;
  },
  GEOCODE_SET_SELECTED(state, selected) {
    state.GEOCODE_SELECTED = selected;
  },
  GEOCODE_SET_CANDIDATES(state, candidates) {
    state.GEOCODE_CANDIDATES = candidates;
    state.GEOCODE_IS_LOADING = false;
  },

  GEOCODE_SET_ERROR(state, { message, messageType = "danger" }) {
    state.message = message;
    state.messageType = messageType;
    state.GEOCODE_IS_LOADING = false;
  },
  GEOCODE_RESET(state) {
    Object.assign(state, getInitialState());
  },
};

const actions = {
  async GEOCODE_SEARCH({ commit, state, dispatch }, query) {
    console.log(query);
    commit("GEOCODE_SET_QUERY", query);
    if (!query || query.length < 3) {
      return;
    }
    clearTimeout(state.GEOCODE_DEBOUNCE_TIMEOUT);
    state.GEOCODE_DEBOUNCE_TIMEOUT = setTimeout(() => {
      dispatch("_GEOCODE_SEARCH", query);
    }, 1000);
  },
  async _GEOCODE_SEARCH({ commit, state }, query) {
    commit("GEOCODE_SET_LOADING");
    // Try to use the GPS or other map location if available
    let locationContext = {
      x: -123.102,
      y: 49.234,
    };

    try {
      console.log(ESRI_API_KEY);
      const results = await suggest(query, {
        authentication: ESRI_API_KEY,
        params: {
          //location: locationContext,
          maxSuggestions: 5,
        },
      });
      if (results.suggestions && results.suggestions.length) {
        commit("GEOCODE_SET_SUGGESTIONS", results.suggestions);
      } else {
        commit("GEOCODE_SET_SUGGESTIONS", []);
        commit("GEOCODE_SET_ERROR", {
          message: "No suggestions found",
          messageType: "info",
        });
      }
    } catch (error) {
      commit("GEOCODE_SET_SUGGESTIONS", []);
      commit("GEOCODE_SET_ERROR", {
        message: error.message || "Geocoding error",
        messageType: "danger",
      });
    }
  },
  async GEOCODE_SELECT({ commit }, suggestion) {
    commit("GEOCODE_SET_SELECTED", suggestion);
    commit("GEOCODE_SET_LOADING");
    try {
      const results = await geocode({
        magicKey: suggestion.magicKey,
        authentication: ESRI_API_KEY,
        maxLocations: 1,
      });
      console.log(results);
      if (results.candidates && results.candidates.length) {
        commit("GEOCODE_SET_CANDIDATES", results.candidates);
        // [{
        //   address : "New York"
        //   attributes : Object
        //   extent : Object
        //   location : Object
        //   score : 100
        // }....]
        //
        // Use first candidate as top candidate
        //
        const tc = results.candidates[0];
        const selectedLocation = {
          lngLat: {
            lng: tc.location.x,
            lat: tc.location.y,
          },
          bounds: [
            [tc.extent.ymin, tc.extent.xmin],
            [tc.extent.ymax, tc.extent.xmax],
          ],
          name: tc.address,
        };
        return selectedLocation;
      } else {
        commit("GEOCODE_SET_CANDIDATES", []);
        return null;
      }
    } catch (error) {
      commit("GEOCODE_SET_ERROR", {
        message: error.message || "Geocoding error",
        messageType: "danger",
      });
      return null;
    }
  },
  GEOCODE_RESET({ commit }) {
    commit("GEOCODE_RESET");
  },
};

export default {
  getInitialState,
  state,
  getters,
  mutations,
  actions,
};
